import React from 'react';
import { observer } from '../../shared/observer';
import { runBusy, isBusy } from '../../shared/busy';
import { router } from '../../shared/hashRouter';

// Главный экран ЛК — повторяет client_app/HomeScreen:
// карточка с аватаром/ФИО/телефоном, список разделов, кнопка
// «Пригласить друга» (если is_referal), выход.
class ProfileHomeView extends React.Component {
  state = { busy: {}, error: null };

  uploadAvatar = (e) => {
    const f = e.target.files && e.target.files[0];
    // Сбрасываем value сразу — иначе повторный выбор того же файла не вызовет onChange.
    e.target.value = '';
    if (!f || isBusy(this, 'avatar')) return;
    this.setState({ error: null });
    runBusy(this, 'avatar', () => this.props.auth.updateAvatar(f))
      .catch((err) => this.setState({ error: (err && err.message) || 'Не удалось загрузить фото' }));
  };
  removeAvatar = () => {
    if (isBusy(this, 'avatar')) return;
    if (!window.confirm('Удалить аватар?')) return;
    this.setState({ error: null });
    runBusy(this, 'avatar', () => this.props.auth.removeAvatar())
      .catch((err) => this.setState({ error: (err && err.message) || 'Не удалось удалить фото' }));
  };
  logout = () => {
    if (isBusy(this, 'logout')) return;
    if (!window.confirm('Выйти из аккаунта?')) return;
    this.setState({ error: null });
    runBusy(this, 'logout', async () => {
      await this.props.auth.logout();
      window.location.href = '/'; // ставит cookie через ensure_mobile_token при reload
    }).catch((err) => this.setState({ error: (err && err.message) || 'Не удалось выйти' }));
  };

  render() {
    const ci = this.props.auth.clientInfo || {};
    const company = this.props.auth.companyInfo;
    const isReferal = company.referal_info && company.referal_info.is_referal;
    const isBonus = !!company.is_bonus_avaliable;
    const fio = [ci.mobile_last_name, ci.mobile_first_name, ci.mobile_middle_name]
      .filter(Boolean).join(' ') || ci.mobile_fio || '';
    const avatarBusy = isBusy(this, 'avatar');
    const loggingOut = isBusy(this, 'logout');

    const items = [
      { href: '#orders', t: 'Мои заказы' },
      { href: '#addresses', t: 'Мои адреса' },
      { href: '#cards', t: 'Карты оплаты' },
      isBonus && { href: '#bonuses', t: 'Бонусы' },
      { href: '#settings', t: 'Настройки' },
    ].filter(Boolean);

    return (
      <div className="ng-profile">
        <h1>Личный кабинет</h1>

        <section className="ng-profile-card">
          <div className="ng-profile-card__avatar ng-img-box ng-img-box--sm">
            {ci.mobile_avatar_image ? (
              <img className="ng-img" src={ci.mobile_avatar_image.thumb || ci.mobile_avatar_image.original} alt={fio || 'Аватар'} />
            ) : (
              <div className="ng-profile-card__avatar-placeholder">{(fio || '?').slice(0, 1).toUpperCase()}</div>
            )}
            <label className={'ng-profile-card__avatar-edit' + (avatarBusy ? ' is-disabled' : '')} title="Сменить фото">
              <input type="file" accept="image/*" onChange={this.uploadAvatar} disabled={avatarBusy} hidden />
              {avatarBusy ? <span className="ng-inline-spin" /> : <span>📷</span>}
            </label>
          </div>
          <div className="ng-profile-card__info">
            <div className="ng-profile-card__fio">{fio || 'Без имени'}</div>
            {ci.phone && <div className="ng-profile-card__phone">{ci.phone}</div>}
            {ci.email && <div className="ng-profile-card__email">{ci.email}</div>}
            {ci.mobile_avatar_image && (
              <a
                href="#"
                onClick={(e) => { e.preventDefault(); this.removeAvatar(); }}
                className={'ng-profile-card__avatar-remove' + (avatarBusy ? ' is-disabled' : '')}
                aria-disabled={avatarBusy ? 'true' : null}
              >
                Удалить фото
              </a>
            )}
          </div>
        </section>

        {this.state.error && <div className="order-message">{this.state.error}</div>}

        <ul className="ng-profile-list">
          {items.map((it) => (
            <li key={it.href}>
              <a href={it.href} onClick={(e) => { e.preventDefault(); router.go(it.href); }}>
                <span>{it.t}</span>
                <span className="ng-profile-list__chevron">›</span>
              </a>
            </li>
          ))}
        </ul>

        {isReferal && (
          <button type="button" className="btn btn--block" onClick={() => router.go('#invite')}>
            Пригласить друга
          </button>
        )}

        <button
          type="button"
          className={'btn btn--ghost btn--block' + (loggingOut ? ' is-busy' : '')}
          disabled={loggingOut}
          onClick={this.logout}
        >
          Выйти
        </button>
      </div>
    );
  }
}

export const ProfileHome = observer(ProfileHomeView, ['authStore']);



// WEBPACK FOOTER //
// ./app/javascript/website_newgen/js/components/Profile/ProfileHome.jsx